import styled from 'styled-components';

import { media } from 'shared/helpers/styling/styling';

export const StyledLocationFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.phone`
flex-direction: column;
align-items: center;
`}
  ${media.tablet`
justify-content: center;
`}
${media.largeTablet`
justify-content: center;
`}
`;

export const StyledLocationFiltersItem = styled.div`
  width: 360px;
  ${media.phone`
width: 250px;
`}
`;
